import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui, redMui, rydeColors } from "@ryde/theme";

export const SaveRouteIndicatorStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-save-route-indicator",
})`
  border: 1px solid ${greyMui._300};
  color: ${greyMui._500};
  padding-block: 4px;
  padding-inline-start: 10px;
  padding-inline-end: 3px;
  display: flex;
  align-items: center;
  margin-inline-start: auto;
  border-radius: 5px;
  white-space: nowrap;
  cursor: pointer;
  > span {
    min-width: 95px;
    margin-inline-start: 8px;
    margin-inline-end: 8px;
    text-transform: uppercase;
    font-weight: 500;
  }
  .pointerIcon > & {
    cursor: pointer;

    > span {
      cursor: pointer;
    }
  }

  &:hover {
    border: 1px solid ${greyMui._400};
    color: ${greyMui._700};
  }

  &.isYellowState {
    border: 1px solid ${rydeColors.yellowButton};
    color: ${rydeColors.yellowButton};

    &:hover {
      color: ${rydeColors.yellowButtonHover};
      border: 1px solid ${rydeColors.yellowButtonHover};
    }
  }

  &.isDeletedState {
    border: 1px solid ${redMui._700};
    color: ${redMui._700};

    &:hover {
      color: ${redMui._900};
      border: 1px solid ${redMui._900};
    }
  }

  &.isIgnoredState {
    border: 1px solid ${blueGreyMui._300};
    color: ${blueGreyMui._500};

    &:hover {
      color: ${blueGreyMui._600};
      border: 1px solid ${blueGreyMui._400};
    }
  }

  .indicatorIcon {
    height: 18px;
    width: 18px;
    margin-inline: 3px;
  }

  .iconYellow {
    color: ${rydeColors.yellowButton};
  }

  .iconGrey {
    color: ${greyMui._500};
  }

  .iconDeleted {
    color: ${redMui._800};
    stroke: ${redMui._800};
  }

  .iconIgnored {
    color: ${blueGreyMui._400};
  }

  .separator {
    border-inline-end: 1px solid ${greyMui._300};
    height: 20px;
    padding-inline-start: 8px;
  }
`;
